import { defineMessages } from '@dragonraider5/react-intl'
import { stepStatuses } from '../constants'

export default defineMessages({
  [stepStatuses.SOLICITUDE]: {
    id: 'containers.applications.status.SOLICITUDE',
    description: 'Application status name SOLICITUDE',
    defaultMessage: '¿Qué necesitas?'
  },
  [stepStatuses.NEEDS]: {
    id: 'containers.applications.status.NEEDS',
    description: 'Application status name NEEDS',
    defaultMessage: '¿Para qué lo necesitas?'
  },
  [stepStatuses.PEOPLE]: {
    id: 'containers.applications.status.PEOPLE',
    description: 'Application status name PEOPLE',
    defaultMessage: 'Capital humano'
  },
  [stepStatuses.INFO]: {
    id: 'containers.applications.status.INFO',
    description: 'Application status name INFO',
    defaultMessage: 'Otros'
  },
  [stepStatuses.DATA]: {
    id: 'containers.applications.status.DATA',
    description: 'Application status name DATA',
    defaultMessage: 'Datos de la organización'
  },
  [stepStatuses.ACTIVITY]: {
    id: 'containers.applications.status.ACTIVITY',
    description: 'Application status name ACTIVITY',
    defaultMessage: 'Actividad'
  },
  [stepStatuses.FINANCIAL]: {
    id: 'containers.applications.status.FINANCIAL',
    description: 'Application status name FINANCIAL',
    defaultMessage: 'Estado financiero'
  },
  [stepStatuses.DOCUMENTS]: {
    id: 'containers.applications.status.DOCUMENTS',
    description: 'Application status name DOCUMENTS',
    defaultMessage: 'Documentos'
  },
  [stepStatuses.FINISHED]: {
    id: 'containers.applications.status.FINISHED',
    description: 'Application status name FINISHED',
    defaultMessage: 'completa'
  }
})
